import { Component } from '@angular/core';
import { Router } from '@angular/router';
// import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-user-logout',
  imports: [],
  templateUrl: './user-logout.component.html',
  styleUrl: './user-logout.component.css'
})
export class UserLogoutComponent {

  constructor(    
    // private msalService: MsalService,
    private router: Router,    
  ) {
  }
   ngOnInit(): void {
    this.logout();
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   this.msalService.instance.clearCache();   
  //  this.msalService.logoutRedirect({
  //  postLogoutRedirectUri: 'https://immunize.wagsoutreach.com'
  //  }); 
  }

   logout()
  {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['']);
  }
}
